import React from 'react'
import { connect } from 'react-redux'
import find from "lodash/find"

import {
  addBillingAddress,
  selectBillingAddress,
  deleteAddress,
  updateAddress
} from "../actions"

import CheckoutAddressComponent from "./CheckoutAddressComponent"

const mapBillingAddressStateToProps = (state) => {
  const e = state.entities;
  const c = state.constants;
  return {
    addresses: e.BillingAddresses.map(
      id => find(e.Addresses, (address) => address.Id === id)),
    selectedAddressId: e.SelectedBillingAddressId,
    addressType: c.BillingAddressType,
    addressActionCreators: {
      add: addBillingAddress,
      remove: deleteAddress,
      select: selectBillingAddress,
      update: updateAddress
    },
    selectAddressMessage: "Bill to this address",
    sectionLabel: "Billing Address"
  }
};

const mapBillingAddressDispatchToProps = (dispatch) => ({
  onEndEdit: (Id) => dispatch(selectBillingAddress(Id))
})
const CheckoutBillingAddressContainer = connect(
  mapBillingAddressStateToProps,
  mapBillingAddressDispatchToProps
)(CheckoutAddressComponent)

export default CheckoutBillingAddressContainer;